"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GenderEquality = void 0;
var React = __importStar(require("react"));
var GenderEquality = function (_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: className,
    width: "48",
    height: "48",
    viewBox: "0 0 453 604"
  }, React.createElement("g", null, React.createElement("g", null, React.createElement("g", {
    transform: "translate(0.000000, 0.036049)"
  }, React.createElement("path", {
    fill: "#E5331D",
    d: "M285,468c48,0,87.1-39.3,87.1-87.5S333,292.9,285,292.9s-87.1,39.3-87.1,87.5\n        C197.8,428.8,236.9,468,285,468z M452.4,214.4c0.6,0,1.2,0.5,1.2,1.2v90.8c0,0.6-0.5,1.1-1.2,1.1h-30.1c-0.6,0-1.2-0.5-1.2-1.1\n        v-33.8l-39.4,39.6c13.6,19.4,21.7,42.9,21.7,68.4c0,59-43,108.1-99.2,117.3v35.3h35.7c0.6,0,1.1,0.5,1.1,1.1v32.3\n        c0,0.6-0.5,1.2-1.1,1.2h-35.7V602c0,0.6-0.5,1.1-1.2,1.1h-32.2c-0.6,0-1.1-0.5-1.1-1.1v-34.2H234c-0.7,0-1.2-0.5-1.2-1.2v-32.3\n        c0-0.6,0.5-1.1,1.2-1.1h35.7v-34.8c-58.1-7.5-103.2-57.6-103.2-117.8c0-65.6,53.1-118.9,118.4-118.9c27.6,0,52.8,9.5,73,25.4\n        l40-40.1h-36c-0.6,0-1.1-0.5-1.1-1.2v-30.2c0-0.6,0.5-1.2,1.1-1.2L452.4,214.4L452.4,214.4L452.4,214.4z"
  }), React.createElement("path", {
    fill: "#E5331D",
    d: "M338.2,344.6H232.5c-0.6,0-1.1,0.5-1.1,1v25.7c0,0.6,0.5,1.1,1.1,1.1h105.7\n        c0.7,0,1.2-0.5,1.2-1.1v-25.7C339.4,345.1,338.9,344.6,338.2,344.6"
  }), React.createElement("path", {
    fill: "#E5331D",
    d: "M338.2,390.5H232.5c-0.6,0-1.1,0.5-1.1,1.1v25.7c0,0.6,0.5,1,1.1,1h105.7\n        c0.7,0,1.2-0.5,1.2-1v-25.7C339.4,391,338.9,390.5,338.2,390.5"
  }), React.createElement("path", {
    fill: "#E5331D",
    d: "M43.3,45.8c-9.7,0-16.8,3.5-20.8,10.2h-0.2V19.4h42.4V-0.9h-65v83h22.5v-3.3\n        c0-8.7,3.9-13.4,10.8-13.4c7.6,0,10.6,5.2,10.6,13.2v35.6c0,7.8-2.8,13.2-10.4,13.2c-8.4,0-11.4-5.6-11.4-14.3V94.7H-0.6v16.7\n        c0,22.4,8.8,36.7,34,36.7c24.9,0,35-13.2,35-33.7V78.3C68.4,55.2,56.5,45.8,43.3,45.8"
  }), React.createElement("path", {
    fill: "#E5331D",
    d: "M154,30.6h14.6v32.9h-7.4v-6.7c-1.4,4.6-4.2,7.4-9.8,7.4c-8.8,0-12.9-7.1-12.9-16.6V17.8\n        c0-9.6,4.6-16.6,15.4-16.6c11.4,0,14.7,6.3,14.7,15.4V22h-9.4v-6.2c0-3.8-1.4-6-5.1-6s-5.3,2.6-5.3,6.3v33.1c0,3.7,1.5,6.3,5,6.3\n        c3.3,0,5.1-1.9,5.1-5.9v-11H154V30.6L154,30.6z"
  }), React.createElement("polygon", {
    fill: "#E5331D",
    points: "174.6,1.9 199.1,1.9 199.1,10.3 184.9,10.3 184.9,28 195.1,28 195.1,36.3 \n        184.9,36.3 184.9,55 199.1,55 199.1,63.5 174.6,63.5"
  }), React.createElement("polygon", {
    fill: "#E5331D",
    points: "213.4,24.8 213.4,63.5 204.6,63.5 204.6,1.9 214.8,1.9 225.9,37.2 225.9,1.9 \n        234.5,1.9 234.5,63.5 225.5,63.5"
  }), React.createElement("path", {
    fill: "#E5331D",
    d: "M255,55c4.2,0,5.9-2.5,5.9-6.2V16.6c0-3.6-1.6-6.2-5.9-6.2h-4.3v44.7h4.3V55z M271.2,18.5\n        V47c0,9.4-3.9,16.5-14.9,16.5h-15.9V1.9h15.9C267.3,1.9,271.2,8.8,271.2,18.5z"
  }), React.createElement("polygon", {
    fill: "#E5331D",
    points: "277,1.9 301.7,1.9 301.7,10.3 287.4,10.3 287.4,28 297.6,28 297.6,36.3 287.4,36.3 \n        287.4,55 301.7,55 301.7,63.5 277,63.5"
  }), React.createElement("path", {
    fill: "#E5331D",
    d: "M317.5,10.3v19.2h3.4c3.5,0,5-1.8,5-5.1v-9.1c0-3.4-1.5-5-5-5L317.5,10.3L317.5,10.3z\n          M317.5,35.2v28.3h-10.3V1.9h15c10.4,0,14.2,5.2,14.2,13.8v7.9c0,6.6-2.3,10.5-8.2,11.9l9.8,28h-10.8L317.5,35.2z"
  }), React.createElement("polygon", {
    fill: "#E5331D",
    points: "138.5,88.2 163,88.2 163,96.6 148.8,96.6 148.8,114.2 159,114.2 159,122.6 \n        148.8,122.6 148.8,141.2 163,141.2 163,149.7 138.5,149.7"
  }), React.createElement("path", {
    fill: "#E5331D",
    d: "M188.6,136v-33.6c0-3.7-1.6-6.3-5.3-6.3c-3.6,0-5.2,2.6-5.2,6.3V136c0,3.6,1.6,6.3,5.2,6.3\n        S188.6,139.6,188.6,136z M179.5,153.8v-4.2c-8.2-1.4-11.7-7.5-11.7-15.8V104c0-9.6,4.7-16.6,15.5-16.6c10.9,0,15.6,7,15.6,16.6\n        v29.8c0,6.7-2.3,12-7.6,14.5l7.6,1.4v7.7L179.5,153.8z"
  }), React.createElement("path", {
    fill: "#E5331D",
    d: "M234.7,88.2v46.6c0,9.5-4.1,15.7-14.5,15.7c-10.8,0-15.3-6.2-15.3-15.7V88.2h10.2v47.6\n        c0,3.6,1.4,6.1,5.1,6.1c3.7,0,5-2.4,5-6.1V88.2H234.7z"
  }), React.createElement("path", {
    fill: "#E5331D",
    d: "M250.5,130.2h8.2l-4.1-24.7h-0.1L250.5,130.2z M237.5,149.7l11.6-61.6h11.7l11.6,61.6H262\n        l-1.9-11.2h-10.9l-1.8,11.2H237.5z"
  }), React.createElement("polygon", {
    fill: "#E5331D",
    points: "276.8,88.2 287.1,88.2 287.1,141.2 299.4,141.2 299.4,149.7 276.8,149.7"
  }), React.createElement("g", null, React.createElement("g", null), React.createElement("polygon", {
    fill: "#E5331D",
    points: "304.1,149.7 314.4,149.7 314.4,88.2 304.1,88.2"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("polygon", {
    fill: "#E5331D",
    points: "319.3,88.2 346.6,88.2 346.6,96.6 338.1,96.6 338.1,149.7 327.7,149.7 327.7,96.6 \n          319.3,96.6"
  })), React.createElement("g", null, React.createElement("g", null), React.createElement("polygon", {
    fill: "#E5331D",
    points: "371.5,126.3 371.5,149.7 361.2,149.7 361.2,126.3 349.6,88.2 360.5,88.2 \n          366.7,111.4 366.8,111.4 373,88.2 382.8,88.2"
  }))))));
};
exports.GenderEquality = GenderEquality;